export default class common {
  static numberWithCommas(x) {
    if (x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
    return ''
  }

  static getChannelsPreset() {
    return {
      whatsapp: {
        name: 'Whatapp',
        class: 'white--text green botter-whatsapp-icon',
        color: 'green',
        colorHexa: '#25d366'
      },
      messenger: {
        name: 'Messenger',
        class: 'white--text blue botter-messenger-icon',
        color: 'blue',
        colorHexa: '#1890ff'
      },
      facebook: {
        name: 'Facebook',
        class: 'white--text blue botter-facebook-icon',
        color: 'blue',
        colorHexa: '#1877f2'
      },
      twitter: {
        name: 'Twitter',
        class: 'white--text blue botter-twitter-icon',
        color: 'blue',
        colorHexa: '#71c2f5'
      },
      web: {
        name: 'Web',
        class: 'white--text botter-web-icon',
        color: 'orange',
        colorHexa: '#372fac'
      },
      'no-channel': {
        name: 'No Channel',
        class: 'white--text botter-question-icon',
        color: 'red',
        colorHexa: '#FF7F00',
        label: 'Short Interaction'
      },
      'mobile-android': {
        name: 'Andriod',
        class: 'white--text purple botter-andriod-icon',
        color: 'purple',
        colorHexa: '#a4c639'
      },
      'mobile-ios': {
        name: 'IOS',
        class: 'white--text black botter-ios-icon',
        color: 'purple',
        colorHexa: '#000000'
      }
    }
  }

  static getSocialIcon(slug) {
    const iconsPresets = this.getChannelsPreset()

    let item = iconsPresets[slug]
    return item
      ? item
      : iconsPresets['no-channel']
  }

  static handleChannelName(channel) {
    const specialCases = {
      'no user response': 'Short Interactions'
    }
    if (specialCases[channel.toLowerCase()] !== undefined)
      return specialCases[channel.toLowerCase()]
    return channel
  }

  static handlePaymentModelName(model) {
    if(!model) return '24/H Conversations'
    const specialCases = {
      users: 'AU',
      sessions: '24/H Conversations'
    }
    if (specialCases[model.toLowerCase()] !== undefined)
      return specialCases[model.toLowerCase()]
    return model
  }

  static handleReceiverName(name) {
    const specialCases = {
      bot: 'BOTTER'
    }
    if (specialCases[name.toLowerCase()] !== undefined)
      return specialCases[name.toLowerCase()]
    return name
  }

  static humanise(diff) {
    // The string we're working with to create the representation
    let str = ''
    // Map lengths of `diff` to different time periods
    let values = [
      [' year', 365],
      [' month', 30],
      [' day', 1]
    ]

    // Iterate over the values...
    for (let i = 0; i < values.length; i++) {
      let amount = Math.floor(diff / values[i][1])

      // ... and find the largest time value that fits into the diff
      if (amount >= 1) {
        // If we match, add to the string ('s' is for pluralization)
        str += amount + values[i][0] + (amount > 1 ? 's' : '') + ' '

        // and subtract from the diff
        diff -= amount * values[i][1]
      }
    }

    return str
  }
}
